import { call, put, takeLatest } from 'redux-saga/effects';

import * as youtubeActions from './youtubeActions.js';
import { updateYouTubeApiCall } from './youtubeAPI.js';

function* updateYouTubeSaga({ payload }) {
  try {
    const { data } = yield call(updateYouTubeApiCall, payload);
    yield put(youtubeActions.youtubeUpdateStore(data));
  } catch (error) {
    yield put(youtubeActions.youtubeUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* youtubeWatcher() {
  yield takeLatest(youtubeActions.youtubeUpdateRequest.type, updateYouTubeSaga);
}
